import { render, staticRenderFns } from "./MarkerCollection.vue?vue&type=template&id=1019970c&scoped=true"
import script from "./MarkerCollection.vue?vue&type=script&lang=js"
export * from "./MarkerCollection.vue?vue&type=script&lang=js"
import style0 from "./MarkerCollection.vue?vue&type=style&index=0&id=1019970c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1019970c",
  null
  
)

export default component.exports